import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Toast from '../toast'

Vue.use(VueAxios, axios)

export default Vue.component('upload-profile-image', {
  props: [
    'id',
    'token',
    'profileImageSrc',
    'profileImageAlt',
    'isGuardian',
    'maxFileSize',
    'canUploadImage',
    'isDashboard',
    'imageId',
  ],
  data () {
    return {
      imageSrc: this.profileImageSrc,
      imageAlt: this.profileImageAlt,
      isLoading: false,
      showModal: false,
      photoId: this.imageId,
    }
  },
  computed: {
    image () {
      return {
        src: this.imageSrc,
        alt: this.imageAlt
      }
    },
    isPlaceholder () {
      return !parseInt(this.photoId)
    },
    showUploadButton() {
      if (this.isDashboard) {
        if (this.isPlaceholder) {
          return this.isGuardian || this.canUploadImage
        } else {
          return false
        }
      } else {
        return this.isGuardian || this.canUploadImage
      }
    },
  },
  methods: {
    onPickFile () {
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      const files = event?.target?.files || []

      // validate that we have a file to upload
      if (files.length === 0) {
        return
      }

      // validate image size (we use a constant on server side to define size in one place.)
      if (files[0].size >= this.maxFileSize) {
        return this.$toast.error({
          component: Toast,
          props: {
            heading: 'Picture upload error',
            body: 'Image size exceeds 2MB.'
          }
        })
      }

      // validate image extension
      if (files[0].type === 'image/*') {
        return this.$toast.error({
          component: Toast,
          props: {
            heading: 'Picture upload error',
            body: 'Upload a valid image. Only PNG and JPEG are allowed.'
          }
        })
      }

      this.isLoading = true
      this.submitFile(files[0])
    },
    submitFile (file) {
      const data = new window.FormData()
      const dashboardLink = this.isGuardian ? '/my-companion-animals/upload/' : '/implanter/dashboard/upload/'
      const url = dashboardLink + this.id + '?FormToken=' + this.token
      data.append('file', file)
      this.showModal = false
      this.axios({
        method: 'POST',
        url,
        headers: { 'content-type': 'multipart/form-data' },
        data,
        maxRedirects: 0
      })
        .then(data => {
          this.imageSrc = data?.data?.image?.src
          this.imageAlt = data?.data?.image?.alt
          this.photoId = data?.data?.image?.photoId
          this.isPlaceholder = false
          this.isLoading = false
          this.$toast.success({
            component: Toast,
            props: {
              heading: 'Profile picture updated',
              body: "Your Companion Animal's profile picture was successfully updated."
            }
          })
        })
        .catch(error => {
          const errors = error?.response?.data?.errors || [0]
          errors.forEach(element => {
            this.$toast.error({
              component: Toast,
              props: {
                heading: 'Picture upload error',
                body: element?.value || ''
              }
            })
          })
          this.isLoading = false
        })
    }
  }
})
